import WarningIcon from "@redotech/redo-icons/alert-circle.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { lowercaseFirstLetter } from "@redotech/string/transform";
import { memo } from "react";
import { InvalidFlowStep } from "../steps";

interface InvalidStepsListProps {
  autoFocus?: boolean;
  invalidSteps: InvalidFlowStep[];
  onGoToStep: (id: string) => void;
}

export const InvalidStepsList = memo(function InvalidStepsList({
  autoFocus,
  invalidSteps,
  onGoToStep,
}: InvalidStepsListProps) {
  if (!invalidSteps.length) {
    return null;
  }

  return (
    <Flex dir="column">
      {invalidSteps.map((step) => (
        <Card key={step.id} p="sm" radius="sm">
          <Flex>
            <Flex>
              <RedoFeaturedIcon color="warning" Icon={WarningIcon} size="sm" />
            </Flex>
            <Flex dir="column">
              <Text fontSize="sm" fontWeight="medium" textColor="primary">
                Incomplete {lowercaseFirstLetter(step.title)} step
              </Text>
              <Flex>
                <RedoButton
                  autoFocus={autoFocus}
                  hierarchy="primary"
                  onClick={() => onGoToStep(step.id)}
                  size="xs"
                  text="Fix step"
                />
              </Flex>
            </Flex>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
});
